export default "__VITE_ASSET__D3X2YKpZ__"